export default {
      id: "member-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "svgsprite.svg#member",
      toString: function () {
        return this.url;
      }
    }